import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledTypography = styled(Typography)(() => ({
  fontWeight: 700,
}));

export default StyledTypography;
